import React, { useState } from 'react';

// Components

import BlockWrapper from './BlockWrapper';

import { householdMemberTools } from '@utils/tools/householdMemberTools';


const BloodRelationshipsInfo = props => {

    const {
        bloodRelationship,
        id,
        householdMembers,
        loadedRelations
    } = props;
    
    const [ description, toggleDescription ] = useState(null);
    
    const handleMouseHovering = (e, br) => {
        toggleDescription({
            br,
            mousePosition: { x: e.clientX, y: e.clientY }
        });
    };
    
    const handleMouseLeaving = () => {
        toggleDescription(null);
    };

    const getRelation = () => {
        return (
            <div style={{ fontSize: '1.2rem' }}>
                <div>
                    {
                        householdMemberTools
                            .extractFromHouseholdMembers(householdMembers)
                            .getFullNameByHhmGuid(description.br.personGuid)
                    }
                </div>&nbsp; to
                <div>
                    {
                        householdMemberTools
                            .extractFromHouseholdMembers(householdMembers)
                            .getFullNameByHhmGuid(description.br.relatedPersonGuid)
                    }
                </div>&nbsp;
                <div style={{ color: 'red' }}> { (br => br ? br.type : 'BR not found')(loadedRelations.find(br => br.code === description.br.relation)) } </div>
            </div>
        );
    };

    const getRelationships = () => {

        const preparedBloodRelationships = Object.values(bloodRelationship.reduce((res, br) => {
            return res[br.personGuid] ?
                { ...res, [br.personGuid]: [ ...res[br.personGuid], br  ] } :
                { ...res, [br.personGuid] : [ br ] };
        }, {}));

        return preparedBloodRelationships
            .map((chunk, idx) => {

                const getRelationsForTheSamePerson = chunk => {

                    return chunk.map(br => {
                        const {
                            relation,
                            personGuid,
                            relatedPersonGuid
                        } = br;

                        return (
                            <span
                                key={`${personGuid}_${relatedPersonGuid}`}
                                style={{
                                    float: 'left',
                                    borderRadius: '3px',
                                    backgroundColor: relation === null ? 'lightgrey' : 'white',
                                    padding: '3px',
                                    margin: '3px',
                                    fontSize: '8px'
                                }}
                                onMouseEnter={e => handleMouseHovering(e, br)}
                                onMouseLeave={() => handleMouseLeaving()}
                            >
                                { Object.entries(br).map(([ propName, value ]) => {
                                    return (
                                        <span
                                            key={Math.random()}
                                            style={{ display: 'block', ...(value === null ? { color: 'red' } : {}) }}

                                        >
                                            { `${propName}: ${value}` }
                                        </span>
                                    );
                                }) }
                                {
                                    description &&
                                    <span
                                        style={{
                                            position: 'fixed',
                                            top: description.mousePosition.y,
                                            left: description.mousePosition.x,
                                            width: '200px',
                                            height: '100px',
                                            backgroundColor: 'white',
                                            borderRadius: '0.5rem',
                                            padding: '1.0rem',
                                            border: '1px solid black',
                                            zIndex: 50000
                                        }}
                                    >
                                        { getRelation() }
                                    </span>
                                }
                            </span>
                        );
                    });
                };

                return (
                    <span
                        key={idx}
                        style={{
                            float: 'left',
                            border: '2px solid black',
                            borderRadius: '3px',
                            padding: '3px',
                            margin: '3px',
                            fontSize: '8px'
                        }}
                    >
                        {
                            getRelationsForTheSamePerson(chunk)
                        }
                    </span>
                );
            });
    };


    return (
        <BlockWrapper id={id} additionalStyles={{ overflowY: 'auto', height: '400px' }}>
            { getRelationships() }
        </BlockWrapper>
    );
};

export default BloodRelationshipsInfo;